export function digitsOnlyPhone(value) {
  return String(value || '').replace(/\D/g, '');
}

export function normalizeComparableName(value) {
  return String(value || '').trim().toLowerCase();
}

export function normalizeLicensePlate(tag) {
  return String(tag || '').replace(/[\s-]/g, '').toLowerCase();
}

/**
 * Match first + last name (trimmed, case-insensitive) and primary phone (digits only)
 * against an existing customer's phone, mobile_phone, or home_phone.
 */
export function findDuplicateCustomer(customers, { firstname, lastname, phone }) {
  const fn = normalizeComparableName(firstname);
  const ln = normalizeComparableName(lastname);
  const p = digitsOnlyPhone(phone);
  if (!fn || !ln || !p) return null;
  return (
    (customers || []).find((c) => {
      if ((c.status || 'active') === 'inactive') return false;
      if (normalizeComparableName(c.firstname) !== fn) return false;
      if (normalizeComparableName(c.lastname) !== ln) return false;
      const phones = [c.phone, c.mobile_phone, c.home_phone].map(digitsOnlyPhone);
      return phones.some((cp) => cp && cp === p);
    }) || null
  );
}

export function findDuplicateVehicleByPlate(vehicles, tag) {
  const n = normalizeLicensePlate(tag);
  if (!n) return null;
  return (
    (vehicles || []).find((v) => {
      if ((v.status || 'active') === 'inactive') return false;
      return normalizeLicensePlate(v.tag) === n;
    }) || null
  );
}

/**
 * When `type` is set, only match resources of that type (and same type_other when type is "other").
 * When `type` is empty, match any resource with the same name and office phone.
 */
export function findDuplicateResourceByNameAndPhone(
  resources,
  { name, phone, type, typeOther }
) {
  const nm = normalizeComparableName(name);
  const p = digitsOnlyPhone(phone);
  if (!nm || !p) return null;
  const tOther = normalizeComparableName(typeOther || '');
  return (
    (resources || []).find((r) => {
      if ((r.status || 'active') === 'inactive') return false;
      if (normalizeComparableName(r.name) !== nm) return false;
      if (digitsOnlyPhone(r.phone) !== p) return false;
      if (type) {
        if ((r.type || '') !== type) return false;
        if (type === 'other' && normalizeComparableName(r.type_other || '') !== tOther) {
          return false;
        }
      }
      return true;
    }) || null
  );
}
